import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { routesSelector, isLoadingSelector } from 'reduxModules/selectors/RouteSelectors'

import { RoutesBase } from './Routes'

const mapStateToProps = createStructuredSelector({
  routes: routesSelector,
  isLoading: isLoadingSelector
})

export const Routes = connect(mapStateToProps)(RoutesBase)



// WEBPACK FOOTER //
// ./src/components/Routes/index.js